<template>
  <ConfigSection
    heading="PUBLISHING.DETAIL.PRODUCTS.FEEDBACK.HEADING"
    subheading="PUBLISHING.DETAIL.PRODUCTS.FEEDBACK.SUBHEADING"
    secondary
  >
    <a :href="`mailto:${mail}`" class="link link-main icon-link">
      <Icon icon="speech-bubble" />{{ $t('GENERAL.GIVE_FEEDBACK') }}
    </a>
  </ConfigSection>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { usePublishingStore } from 'commons/stores/publishing';
import contactData from 'commons/contactData/contactData';
import ConfigSection from 'src/app/components/publishing/ConfigSection.vue';

const publishingStore = usePublishingStore();

const mail = computed(() => {
  return contactData.getMailForPublishingScope(publishingStore.currentScope);
});
</script>
